import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';

import {PrimaryButton} from 'Components/Button';
import {
    FormHandler,
    Input,
    Label,
    FileUpload,
    Textarea,
    BooleanSelect,
    Dietaries,
    EmergencyContactDetails,
    Radio
} from 'Components/Form';
import {Alert, Loading} from 'Components/Partials';
import {DisplayTimeZone, DisplayLanguage} from 'Components/Settings';
import {MailLink} from 'Components/Utilities';

import {getFallbackAvatarUrl} from 'Services/AuthHelpers';
import Me from 'Services/Api/Me/Me';

import SettingsLayout from 'Components/Layouts/SettingsLayout';
import AdminLayout from 'Pages/Admin/AdminLayout';
import { User } from "Services";

class Profile extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your details have been updated successfully';

    /**
     * @var displayAvatar
     * @type {boolean}
     */
    displayAvatar = false;

    /**
     * @var state
     */
    state = {
        loading: true,
        user_id: this.props.match?.params?.user ?? null,
        success: false,
        invitesShown: []
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.loadUser();
    };

    /**
     * @method loadUser
     */
    loadUser = async () => {
        const {user_id} = this.state;

        // Request the data.
        const response = await Me.getMe({
            includeHasInvited: true,
            user_id
        });

        // Increment the invites array keys as we are 1 based for this form.
        let invites = [];

        if (response.data.data.has_invited.length > 0) {
            for (var i=0; i < response.data.data.has_invited.length; i++) {
                invites[i+1] = response.data.data.has_invited[i];
            }
        } else {
            invites[1] = {
                position: 'Store Manager',
            };
        }

        // Set the form values.
        this.props.setForm({
            ...response.data.data,
            invites,
            user_id
        });

        // Finish loading.
        this.setState({
            loading: false
        });
    }

    /**
     * @method getFormValues
     * @param {integer|null} index
     * @return {object}
     */
    getFormValues = (index) => {
        const {form} = this.props;

        return index !== null ?
            (form['invites'] && form['invites'][index] ?
                form['invites'][index] :
                null) :
            form;
    }

    /**
     * @method getFormkey
     * @param {integer|null} index
     * @return {string}
     */
    getFormkey = (index) => {
        return index !== null ?
            'invites.' + index + '.' :
            '';
    }

    /**
     * @method handleToggleInvite
     * @param {integer} index
     */
    handleToggleInvite = (index) => {
        const {invitesShown} = this.state;

        this.setState({
            invitesShown: {
                ...invitesShown,
                [index]: !invitesShown[index]
            }
        });
    }

    /**
     * @method handleSuccess
     */
    handleSuccess = () => {
        this.setState({
            success: true
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {user_id} = this.state;

        if (user_id) {
            return (
                <AdminLayout title={'Users - Profile'}>
                    {this.renderPage()}
                </AdminLayout>
            );
        }

        return (
            <SettingsLayout title="Registration">
                {this.renderPage()}
            </SettingsLayout>
        );
    }

    /**
     * @method renderPage
     * @return {JSX.Element}
     */
    renderPage() {
        const {success} = this.state;

        if (success) {
            return this.renderSuccess();
        }

        return this.renderPage2();
    }

    /**
     * @method renderPage2
     * @return {JSX.Element}
     */
    renderPage2() {
        const {loading} = this.state;
        const {form, working, alert, handleInput, handleSubmit} = this.props;

        if (loading) {
            return <Loading />;
        }

        return (
            <form
                autoComplete="off"
                onSubmit={(e) => handleSubmit(e, Me.update, this.handleSuccess)}
            >
                <div className="p-6 text-center  max-w-6xl mx-auto">
                    <h2 className="text-black text-4xl mb-4 font-bold">
                        Registration
                    </h2>

                    {this.renderProfileCopy()}
                </div>

                <div className="p-6">
                    {alert !== null && (<Alert {...alert} />)}

                    {this.displayAvatar &&
                        <FileUpload
                            containerClassName="m-8 mt-4 flex flex-col justify-center items-center gap-4"
                            value={form.avatar_path}
                            onChange={v => handleInput('avatar_path', v)}
                            accept="image/*"
                            placeholder="Update Picture"
                            fallbackImage={getFallbackAvatarUrl(form)}

                        />
                    }

                    {this.renderForm(null, form.first_group_name)}

                    {form.number_of_invites > 0 && this.renderInvites()}
                </div>

                <div className="p-6 flex justify-between">
                    <PrimaryButton
                        text="Save"
                        working={working}
                    />
                </div>
            </form>
        );
    }

    /**
     * @method renderProfileCopy
     * @return {JSX.Element}
     */
    renderProfileCopy() {
        const {form} = this.props;
        return (
            <>
                {form.first_group_name === 'Store Manager' &&
                    <>
                        <p className="text-black font-light w-full mx-auto mt-2 text-2xl">
                            We are so excited to invite your advisors to the Fragrance virtual conference 2023,
                            taking place on Thursday 22nd June.
                            {/*{form.event_date === '5th' ?
                                'Wednesday 5th October' :
                                (form.event_date === '6th' ? 'Thursday 6th October' : 'N/A')}
                            {" "}please check your details are correct below and enter your advisors’ details. */}
                        </p>

                        <p className="text-black font-light w-full mx-auto mt-2 text-2xl">
                            To register yourself and one advisor please complete the following information.
                            <br />
                            Please note registration will close on Friday 16th June.
                        </p>
                    </>
                }

                {(form.first_group_name === 'Support Office' || form.first_group_name === 'Regional Field Team') &&
                    <>
                        <p className="text-black font-light w-full mx-auto mt-2 text-2xl">
                            To register, please complete the following information.
                            <br />
                            Please note registration will close Friday 16th June.
                        </p>
                    </>
                }
                {form.number_of_invites > 0 &&
                    <p className="text-black text-center mt-2 font-light">
                        The number of advisors you can invite is: 1.
                    </p>
                }

{/*                {form.first_group_name === 'Store Manager' &&
                    <div className="bg-gray-200 p-4 text-app-blue-dark text-center mt-6">
                        <p className="text-2xl">
                            Travel
                        </p>

                        <p className="mt-2">
                            Each attendee will need to self-book their travel via Concur using their OneID login details,
                            your Store Manager should be able to guide you through the process, communication and guidance is also on{" "}
                            <a
                                href="https://nsp.bootslive.co.uk/sites/bootslive/AllUsers/Pages/Concur-for-travel-and-expenses-UK-and-Ireland.aspx"
                                target="_blank"
                            >
                                BootsLive.
                            </a>
                        </p>

                        <p className="mt-2">
                            The day will start with registration from 08:30am and the plenary will start at 09:30am,
                            it will finish at 16:30. Further details will follow but, for now,
                            please make sure that any travel booked enables time to get to the railway
                            station/airport after the end of the day.
                        </p>

                        <p className="mt-2">
                            The cost centre to charge for travel is 33071, there is no need to book accommodation
                            as this is provided centrally by the event team.
                        </p>
                    </div>
                }*/}
            </>
        );
    }

    /**
     * @method renderPage
     * @return {JSX.Element}
     */
    renderInvites() {
        const {invitesShown} = this.state;
        const {form} = this.props;
        return (
            <>
                {[...Array(form.number_of_invites)].map((e, i) => (
                    <div key={i}>
                        <div
                            className={`
                                text-white text-3xl bg-gray-500 w-full cursor-pointer px-4 py-2 mt-8 mb-4
                                select-none flex flex-row justify-between items-center
                            `}
                            onClick={() => this.handleToggleInvite(i)}
                        >
                            <p>
                                {form.number_of_invites > 1 && i === 0 ? 'Store Manager' : 'Advisor ' + i}
                            </p>

                            <FontAwesomeIcon
                                icon={invitesShown[i] ? faCaretUp : faCaretDown}
                            />
                        </div>

                        {invitesShown[i] && this.renderForm((i+1), 'Advisor')}
                    </div>
                ))}
            </>
        );
    }

    /**
     * @method renderPage
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderForm(index, group_name) {
        const {form} = this.props;

        let values = this.getFormValues(index);
        let key = this.getFormkey(index);

        if (group_name === 'Advisor') {
            return this.renderAdvisorForm(values, key);
        } else if (group_name === 'Store Manager') {
            return this.renderStoreManagerForm(values, key);
        }else if (group_name === 'Support Office' || group_name === 'Regional Field Team') {
            return this.renderSupportOfficeForm(values, key);
        } else {
            return (
                <p className="text-app-blue-dark mt-6 text-center">
                    You do not need to register.
                </p>
            );
        }
    }

    /**
     * @method renderAdvisorForm
     * @param {object|null} values
     * @param {string} key
     * @return {JSX.Element}
     */
    renderAdvisorForm(values, key) {
        const {form, handleInput, getFieldError} = this.props;
        return (
            <div className="flex flex-col gap-4 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-200 p-4">
                    {key !== 'invites.1.' && (
                        <>
                            <Input
                            label="Employee Number"
                            value={values?.employee_number}
                            id="employee_number"
                            error={getFieldError(key + 'employee_number')}
                            onChange={(v) => handleInput(key + 'employee_number', v)}
                            containerClassName={"flex flex-row"}
                        />

                            <Input
                                label="First Name"
                                value={values?.first_name}
                                id="first_name"
                                error={getFieldError(key + 'first_name')}
                                onChange={(v) => handleInput(key + 'first_name', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="Last Name"
                                value={values?.last_name}
                                id="last_name"
                                error={getFieldError(key + 'last_name')}
                                onChange={(v) => handleInput(key + 'last_name', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="Position"
                                value={values?.position}
                                id="position"
                                error={getFieldError(key + 'position')}
                                onChange={(v) => handleInput(key + 'position', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label={'Email'}
                                value={values?.email}
                                id="email"
                                error={getFieldError(key + 'email')}
                                onChange={(v) => handleInput(key + 'email', v)}
                                readOnly={!window.base.features.allow_email_change && !key}
                                containerClassName={"flex flex-row"}
                            />

                            <Textarea
                                label="Do you need any assistance with viewing?"
                                value={values?.special_access_requirements}
                                id="special_access_requirements"
                                error={getFieldError(key + 'special_access_requirements')}
                                onChange={(v) => handleInput(key + 'special_access_requirements', v)}
                            />
                        </>
                    )}
                    {key === 'invites.1.' && (
                        <>
                            <Input
                                label="First Name"
                                value={values?.first_name}
                                id="first_name"
                                error={getFieldError(key + 'first_name')}
                                onChange={(v) => handleInput(key + 'first_name', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="Last Name"
                                value={values?.last_name}
                                id="last_name"
                                error={getFieldError(key + 'last_name')}
                                onChange={(v) => handleInput(key + 'last_name', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="Position"
                                value={values?.position ?? 'Store Manager'}
                                id="position"
                                error={getFieldError(key + 'position')}
                                onChange={(v) => handleInput(key + 'position', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label={`Email`}
                                value={values?.email ?? User.data.email}
                                id="email"
                                error={getFieldError(key + 'email')}
                                onChange={(v) => handleInput(key + 'email', v)}
                                readOnly={!window.base.features.allow_email_change && !key}
                                containerClassName={"flex flex-row"}
                            />

                            <Textarea
                                label="Do you need any assistance with viewing?"
                                value={values?.special_access_requirements}
                                id="special_access_requirements"
                                error={getFieldError(key + 'special_access_requirements')}
                                onChange={(v) => handleInput(key + 'special_access_requirements', v)}
                                containerClassName={"flex flex-row"}
                            />
                        </>
                    )}
                </div>

                {/*<div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-200 p-4">
                    <Dietaries
                        value={values?.dietaries}
                        error={getFieldError(key + 'dietaries')}
                        onChange={(v) => handleInput(key + 'dietaries', v)}
                        containerClassName={"flex flex-row"}
                    />
                </div>*/}

                {/*<div className="bg-gray-200 p-4">
                    <BooleanSelect
                        label={`
                            Accommodation is available on the night prior to the event,
                            for those that are having to travel over 3 hours. Do your advisors require accommodation?
                        `}
                        value={values?.accomodation}
                        id="accomodation"
                        error={getFieldError(key + 'accomodation')}
                        onChange={(v) => handleInput(key + 'accomodation', v)}
                    />
                </div>*/}

                {/*<div>
                    <EmergencyContactDetails
                        value={values?.emergency_contact_details}
                        error={getFieldError(key + 'emergency_contact_details')}
                        onChange={(v) => handleInput(key + 'emergency_contact_details', v)}
                    />
                </div>*/}
            </div>
        );
    }

    /**
     * @method renderStoreManagerForm
     * @param {object|null} values
     * @param {string} key
     * @return {JSX.Element}
     */
    renderStoreManagerForm(values, key) {
        const {handleInput, getFieldError} = this.props;

        return (
            <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 font-light">
                    <Input
                        label="Store Number"
                        value={values?.store_number}
                        id="store_number"
                        error={getFieldError(key + 'store_number')}
                        onChange={(v) => handleInput(key + 'store_number', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Store Name"
                        value={values?.store_name}
                        id="store_name"
                        error={getFieldError(key + 'store_name')}
                        onChange={(v) => handleInput(key + 'store_name', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Store Address"
                        value={values?.store_address}
                        id="store_address"
                        error={getFieldError(key + 'store_address')}
                        onChange={(v) => handleInput(key + 'store_address', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Region"
                        value={values?.region}
                        id="region"
                        error={getFieldError(key + 'region')}
                        onChange={(v) => handleInput(key + 'region', v)}
                        containerClassName={"flex flex-row"}
                    />

                    {/*<Input
                        label="Email address"
                        value={values?.email}
                        id="email"
                        error={getFieldError(key + 'email')}
                        onChange={(v) => handleInput(key + 'email', v)}
                        readOnly={!window.base.features.allow_email_change && !key}
                        containerClassName={"flex flex-row"}
                    />*/}
                    <div className="flex flex-row">
                        <Label className="mb-0 font-light w-1/3" label="Will you be attending?" />

                        <div className="flex flex-row space-x-2 font-light">
                            <Radio
                                id="attending-yes"
                                label="Yes"
                                labelPlacement="right"
                                value={values?.is_attending === true}
                                onChange={e => handleInput('is_attending', true)}
                            />
                            <Radio
                                id="attending-no"
                                label="No"
                                labelPlacement="right"
                                value={values?.is_attending === false}
                                onChange={e => handleInput('is_attending', false)}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }

    /**
     * @method renderStoreManagerForm
     * @param {object|null} values
     * @param {string} key
     * @return {JSX.Element}
     */
    renderSupportOfficeForm(values, key) {
        const {handleInput, getFieldError} = this.props;

        return (
            <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 font-light">
                    <Input
                        label="First Name"
                        value={values?.first_name}
                        id="first_name"
                        error={getFieldError(key + 'first_name')}
                        onChange={(v) => handleInput(key + 'first_name', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Last Name"
                        value={values?.last_name}
                        id="last_name"
                        error={getFieldError(key + 'last_name')}
                        onChange={(v) => handleInput(key + 'last_name', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Role"
                        value={values?.position}
                        id="position"
                        error={getFieldError(key + 'position')}
                        onChange={(v) => handleInput(key + 'position', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Email address"
                        value={values?.email}
                        id="email"
                        error={getFieldError(key + 'email')}
                        onChange={(v) => handleInput(key + 'email', v)}
                        readOnly={!window.base.features.allow_email_change && !key}
                        containerClassName={"flex flex-row"}
                    />
                </div>
            </>
        );
    }

    /**
     * @method renderSuccess
     * @return {JSX.Element}
     */
    renderSuccess() {
        const {form} = this.props;

        return (
            <div className={"max-w-3xl mx-auto"}>
                <h2 className="text-center font-bold text-black text-6xl">
                    Thank you
                </h2>
                {(form.first_group_name === 'Store Manager' || form.first_group_name === 'Support Office' || form.first_group_name === 'Regional Field Team') && (
                    <div className="text-center font-bold mt-6 text-xl">
                        {(form.first_group_name === 'Store Manager' ||  form.first_group_name === 'Regional Field Team') && (
                            <p>
                                You have successfully registered
                                {form.invites[1] && form.invites[1].email && (
                                    <span>{" "}{form.invites[1].email}{" "}</span>
                                )}
                                {form.invites[2] && form.invites[2].email && (
                                    <span> and {" "}{form.invites[2].email} {" "}</span>
                                )}
                                for the Fragrance event on Thursday 22nd June.
                            </p>
                        )}
                        {form.first_group_name === 'Support Office' && (
                            <p>
                                You have successfully registered for the Fragrance event on Thursday 22nd June.
                            </p>
                        )}

                        <p className="p-2 m-2 font-light text-xl">
                            A confirmation email has been sent to your email address.
                        </p>

                        <p className="p-2 m-2 font-light text-xl">
                            If you do not see the email in a few minutes,
                            please check your junk inbox in case it has slipped into this folder.
                        </p>

                        <p className="p-2 m-2 font-light text-xl">
                            You will receive full joining instructions and further information
                            about how to log on to the event site a few days before the event.
                        </p>

                        <p className="p-2 m-2 font-light text-xl">
                            If you have any questions about the event, please contact  <MailLink/>
                        </p>
                    </div>
                )}
                {form.first_group_name === 'Advisor' &&
                    <div className="text-center text-black font-bold text-6xl mt-6">
                        <p>
                            You have successfully registered to attend the Fragrance Conference.
                        </p>
                    </div>
                }
            </div>
        );
    }
}

export default FormHandler(Profile);
